import { eventCategories } from '@/constants';
import { useSignUp } from '@/contexts/signup.context.jsx';

export const CategoriesForm = () => {
	const { categories: selected, setCategories } = useSignUp();
	const filteredCategories = eventCategories.filter((c) => c.name?.toLowerCase() !== 'legal');

	return (
		<div className="grid grid-cols-2 gap-4 w-full overflow-y-auto form-maxh-category hide-scrollbar">
			{filteredCategories.map((category) => {
				const isSelected = selected.includes(category.id);
				const iconSrc = category.icon;
				if (!iconSrc) return;

				return (
					<button
						key={category.id}
						onClick={() =>
							setCategories((prev) =>
								prev.includes(category.id)
									? prev.filter((c) => c !== category.id)
									: [...prev, category.id]
							)
						}
						className={`flex flex-col gap-1 items-center justify-center rounded-[30px] border border-blue-custom-2 px-4 py-3 text-sm font-bold transition-all
              ${isSelected ? 'bg-blue-custom-2 text-[#F7F7F8]' : 'text-[#F7F7F8]'}`}
					>
						{iconSrc && (
							<img
								src={iconSrc}
								alt={category.name || 'category'}
								className="w-8 h-8 object-contain"
							/>
						)}
						{category.name}
					</button>
				);
			})}
		</div>
	);
};
